import type { CargoProblemStatus } from '@magimp/shared';
import { StatusBadge } from '../../../ui/index.js';
import { cargoProblemBadgeStatus, useCargoProblemLabels } from '../labels.js';

export function CargoProblemStatusBadge({ status }: { status: CargoProblemStatus }) {
  const labels = useCargoProblemLabels();
  return (
    <StatusBadge size="sm" status={cargoProblemBadgeStatus(status)} label={labels.status(status)} />
  );
}
